import {
  isPaymentMethodApplePay,
  isPaymentMethodCC,
  isPaymentMethodPayPal,
} from '#common/utils/payment'

export const usePaymentMethods = defineStore('paymentMethods', () => {
  const { $axios } = useNuxtApp()

  const init = ref(false)
  const loading = ref(false)
  const defaultPaymentOption = ref(null)
  const defaultPaymentMethod = ref(null)
  const userPaymentMethods = ref([])

  const paypalMethods = computed(() =>
    userPaymentMethods.value.filter((x) => x.is_paypal),
  )
  const applePayMethods = computed(() =>
    userPaymentMethods.value.filter((x) => x.is_applepay),
  )
  const creditCardMethods = computed(() =>
    userPaymentMethods.value.filter((x) => x.is_cc),
  )

  const addPaymentMethod = async (paymentMethod) => {
    userPaymentMethods.value.push(paymentMethod)
    await loadPaymentMethods(true)
  }

  async function loadPaymentMethods(force = false) {
    if (init.value && !force) return userPaymentMethods.value
    init.value = true
    loading.value = true
    const { data } = await $axios.get('/api/payment/card/?include_non_cc=true')

    userPaymentMethods.value =
      _.map(data, (pm) => ({
        ...pm,
        is_paypal: isPaymentMethodPayPal(pm),
        is_applepay: isPaymentMethodApplePay(pm),
        is_cc: isPaymentMethodCC(pm),
      })) || []

    defaultPaymentOption.value = 'paymentOptionCreditCard'
    defaultPaymentMethod.value = null

    userPaymentMethods.value.forEach((paymentMethod) => {
      if (paymentMethod.is_default) {
        if (paymentMethod.is_paypal) {
          defaultPaymentOption.value = 'paymentOptionPayPal'
        } else if (paymentMethod.is_applepay) {
          defaultPaymentOption.value = 'paymentOptionApplePay'
        } else {
          defaultPaymentOption.value = 'paymentOptionCreditCard'
        }
        defaultPaymentMethod.value = paymentMethod.card_id
      }
    })

    loading.value = false
    return userPaymentMethods.value
  }

  async function reloadPaymentMethods() {
    return await loadPaymentMethods(true)
  }

  function clearPaymentMethods() {
    init.value = false
    loading.value = false
    userPaymentMethods.value = []
    defaultPaymentOption.value = null
    defaultPaymentMethod.value = null
  }

  return {
    init,
    loading,
    defaultPaymentOption,
    defaultPaymentMethod,
    userPaymentMethods,
    paypalMethods,
    applePayMethods,
    creditCardMethods,
    addPaymentMethod,
    loadPaymentMethods,
    reloadPaymentMethods,
    clearPaymentMethods,
  }
})
